<template>
  <div class="about">
    <Header 
      title="Ranking" 
      subtitle="Servidores Forfun / DM"
    ></Header>
    <div class="container">
      <div class="stats-table table-responsive">
        <table class="table is-hoverable">
          <thead>
            <tr>
              <th><abbr title="#">#</abbr></th>
              <th><abbr title="Nome">Nome</abbr></th>
              <th><abbr title="Kills">Kills</abbr></th>
              <th><abbr title="Deaths">Deaths</abbr></th>
              <th><abbr title="Shots">Shots</abbr></th>
              <th><abbr title="Hits">Hits</abbr></th>
              <th><abbr title="HS">HS</abbr></th>
              <th><abbr title="Assist">Assist</abbr></th>
              <th><abbr title="Damage">Damage</abbr></th>
              <th><abbr title="Seconds on Server">Seconds on Server</abbr></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(player, index) in players" :key="player.id">
              <td>{{index+1}}</td>
              <td v-if="player.user">
                <router-link :to="{ name: 'UserSingle', params: { id: player.user.id }}">
                  {{player.user.nickname}}
                </router-link>
              </td>
              <td v-if="!player.user">{{ player.name }}</td>
              <td>{{ player.kills }}</td>
              <td>{{ player.deaths }}</td>
              <td>{{ player.shots }}</td>
              <td>{{ player.hits }}</td>
              <td>{{ player.headshots_percentage }}</td>
              <td>{{ player.assists }}</td>
              <td>{{ player.damage }}</td>
              <td>{{ player.seconds_on_server }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '@/components/Header'
export default {
  name: 'ForfunStats',
  metaInfo: {
    title: 'Ranking Forfun'
  },
  data () {
    return {
      players: null
    }
  },
  methods: {
    initialize() {
      this.$http
        .get('forfun_stats.json')
        .then(response => (this.players = response.data))
      
    }
  },
  mounted () {
    this.initialize()
  },
  components: {
    Header
  }
}
</script>

<style lang="scss" scoped>
</style>
